import { useDispatch } from 'react-redux'
import * as puzzleDataActions from 'klubble/app/client/actions/puzzleDataActions'
import usePuzzleType from './usePuzzleType'

const usePuzzleTypeFavorite = (puzzleTypeId: number, miniPuzzleTypeId?: number) => {
  const puzzleType = usePuzzleType(puzzleTypeId)
  const isFavorite = puzzleType?.isFavorite ?? false
  const dispatch = useDispatch()

  const toggleIsFavorite = (usePreviousFavorite?: boolean) => {
    // Use the previous favorite state when this function gets stored inside a state and doesn't get the updated isFavorite value
    const setFavorite = usePreviousFavorite ? isFavorite : !isFavorite
    const saveActions = [
      dispatch(puzzleDataActions.savePuzzleSettings({
        puzzleTypeId,
        isFavorite: setFavorite,
      })),
    ]
    if (miniPuzzleTypeId) {
      saveActions.push(dispatch(puzzleDataActions.savePuzzleSettings({
        puzzleTypeId: miniPuzzleTypeId,
        isFavorite: setFavorite,
      })))
    }
    return Promise.all(saveActions)
  }

  return { isFavorite, toggleIsFavorite }
}

export default usePuzzleTypeFavorite
